module.exports = __webpack_public_path__ + "static/img/li.c71cdf86.png";